// @ts-nocheck
import { NumericFormat } from "react-number-format";

export const formatMoney = (value: any) => {
  const res = (
    <NumericFormat
      value={value}
      displayType={"text"}
      thousandSeparator={true}
      prefix={"$"}
    />
  );
  return res;
};

export const formatMoneyExtra = (value: any) => {
  const res = (
    <NumericFormat
      value={value}
      className="foo"
      displayType={"text"}
      thousandSeparator={true}
      prefix={"$"}
      renderText={(value: any, props: any) => (
        <p {...props}>Save {value}/month by purchasing yearly subcription</p>
      )}
    />
  );
  return res;
};

export const formatCurrency = (input: any) => {
  return input
    ?.toString()
    .replace("-", "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
